const DetailArchive = () => import('./Main')

const route = {
  path: '/archive/:id',
  name: 'archive-detail',
  component: DetailArchive
}

export default route
